import { useEffect } from 'react';

/** Protect form input when closing the dialog or leaving the browser page. */
export function useUnsavedChanges(open: boolean, dirty: boolean, onClose: () => void, pending = false): () => void {
  useEffect(() => {
    if (!open || (!dirty && !pending)) return;
    const warn = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [open, dirty, pending]);

  return () => {
    if (pending) return;
    if (!dirty || window.confirm('Deine Änderungen sind noch nicht gespeichert. Wirklich verwerfen?')) onClose();
  };
}
